import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { GardenProvider } from "@/contexts/GardenContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Beds from "@/pages/Beds";
import Crops from "@/pages/Crops";
import Timeline from "@/pages/Timeline";
import Chat from "@/pages/Chat";
import BookNotes from "@/pages/BookNotes";
import CsvImport from "@/pages/CsvImport";
import GardenMap from "@/pages/GardenMap";
import About from "@/pages/About";
import VeggiePreview from "@/pages/VeggiePreview";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Unsubscribe from "@/pages/Unsubscribe";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Profile from "@/pages/Profile";
import PublicGarden from "@/pages/PublicGarden";
import Pricing from "@/pages/Pricing";
import Billing from "@/pages/Billing";
import Images from "@/pages/Images";
import HarvestParty from "@/pages/HarvestParty";
import Pests from "@/pages/Pests";
import PestDetail from "@/pages/PestDetail";
import Beneficials from "@/pages/Beneficials";
import BeneficialDetail from "@/pages/BeneficialDetail";
import Admin from "@/pages/Admin";
import AdminStats from "@/pages/AdminStats";
import AdminTestimonials from "@/pages/AdminTestimonials";
import AdminIllustrations from "@/pages/AdminIllustrations";

export default function App() {
    return (
        <BrowserRouter>
            <AuthProvider>
                <GardenProvider>
                    <Routes>
                        {/* Public routes */}
                        <Route path="/about" element={<About />} />
                        <Route path="/preview/veggies" element={<VeggiePreview />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/register" element={<Register />} />
                        <Route path="/forgot-password" element={<ForgotPassword />} />
                        <Route path="/reset-password" element={<ResetPassword />} />
                        <Route path="/unsubscribe/:token" element={<Unsubscribe />} />
                        <Route path="/share/:token" element={<PublicGarden />} />
                        <Route path="/harvest/:token" element={<HarvestParty />} />
                        <Route path="/pricing" element={<Pricing />} />

                        {/* Authenticated app */}
                        <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
                            <Route index element={<Dashboard />} />
                            <Route path="/map" element={<GardenMap />} />
                            <Route path="/beds" element={<Beds />} />
                            <Route path="/crops" element={<Crops />} />
                            <Route path="/timeline" element={<Timeline />} />
                            <Route path="/chat" element={<Chat />} />
                            <Route path="/book-notes" element={<BookNotes />} />
                            <Route path="/import" element={<CsvImport />} />
                            <Route path="/profile" element={<Profile />} />
                            <Route path="/images" element={<Images />} />
                            <Route path="/pests" element={<Pests />} />
                            <Route path="/pests/:slug" element={<PestDetail />} />
                            <Route path="/beneficials" element={<Beneficials />} />
                            <Route path="/beneficials/:slug" element={<BeneficialDetail />} />
                            <Route path="/admin" element={<Admin />} />
                            <Route path="/admin/stats" element={<AdminStats />} />
                            <Route path="/admin/testimonials" element={<AdminTestimonials />} />
                            <Route path="/admin/illustrations" element={<AdminIllustrations />} />
                            <Route path="/billing" element={<Billing />} />
                            <Route path="/billing/success" element={<Billing />} />
                        </Route>
                    </Routes>
                </GardenProvider>
            </AuthProvider>
            {/* Toaster mounted at the root so every route — public AND
                authenticated — can surface sonner toasts. Previously it
                lived inside Layout.jsx which only wraps protected
                routes, so toast.error/success calls from /login,
                /forgot-password, /reset-password, /register, /about,
                /pricing, /share/* and /harvest/* were silently dropped
                (most visible symptom: ResetPassword "starts updating
                and stops" — the button correctly re-enabled after a
                400, but the user never saw the error toast). */}
            <Toaster richColors />
        </BrowserRouter>
    );
}
